const normalizeCount = (value) => Math.max(0, Math.floor(Number(value) || 0));

function normalizeInventoryItems(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const items = {};
  for (const [rawSlug, rawQty] of Object.entries(raw)) {
    const slug = String(rawSlug || '').trim();
    const qty = normalizeCount(rawQty);
    if (slug && qty > 0) items[slug] = qty;
  }
  return items;
}

export function normalizeNotificationState(raw) {
  const source = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  return {
    captures: normalizeCount(source.captures),
    inventory: normalizeCount(source.inventory),
    inventoryItems: normalizeInventoryItems(source.inventoryItems),
  };
}

export function recordNotification(raw, kind, qty = 1, slug = '') {
  const next = normalizeNotificationState(raw);
  const amount = normalizeCount(qty);
  if (!amount || !['captures', 'inventory'].includes(kind)) return next;

  next[kind] += amount;
  if (kind === 'inventory') {
    const itemSlug = String(slug || '').trim();
    if (itemSlug) next.inventoryItems[itemSlug] = (next.inventoryItems[itemSlug] || 0) + amount;
  }
  return next;
}

export function clearNotificationMarkers(raw, kind) {
  const next = normalizeNotificationState(raw);
  if (kind === 'captures') next.captures = 0;
  if (kind === 'inventory') {
    next.inventory = 0;
    next.inventoryItems = {};
  }
  return next;
}

export function inventoryUnreadQty(raw, slug) {
  const normalized = normalizeNotificationState(raw);
  return normalized.inventoryItems[String(slug || '').trim()] || 0;
}

export function dismissInventoryNotification(raw, slug) {
  const next = normalizeNotificationState(raw);
  const itemSlug = String(slug || '').trim();
  const pending = itemSlug ? next.inventoryItems[itemSlug] || 0 : 0;
  if (!pending) return next;
  delete next.inventoryItems[itemSlug];
  next.inventory = Math.max(0, next.inventory - pending);
  return next;
}

export function dismissCaptureNotification(raw, qty = 1) {
  const next = normalizeNotificationState(raw);
  next.captures = Math.max(0, next.captures - normalizeCount(qty));
  return next;
}
